import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UIState } from './ui.interface';

export const _SELECT_UI_FEATURE = createFeatureSelector<UIState>(
  'sesion-ui-management'
);

export const _SELECT_UI_LOADING_FEATURE =
  createFeatureSelector<UIState>('sesion-ui-loading');

export const _UI_PARAMS_STATE = createSelector(_SELECT_UI_FEATURE, state => {
  return {
    statusError: state.uiError.statusError,
    errorLocation: state.uiError.errorLocation,
    errorMessage: state.uiError.errorMessage,
  };
});

export const _UI_LOADING_STATE = createSelector(
  _SELECT_UI_LOADING_FEATURE,
  (state: UIState) => {
    return state.uiLoading.isLoading;
  }
);
export const _UI_IMAGE_UPLOAD = createSelector(
  _SELECT_UI_LOADING_FEATURE,
  (state: UIState) => {
    return state.uiLoading.isImageUpload;
  }
);

export const _EXIST_ERROR = createSelector(
  _SELECT_UI_FEATURE,
  (state: UIState) => {
    return state.uiError.errorLocation;
  }
);
